module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_contents"
    }
  }, [_vm._v("CHIEF ABBREVIATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AB – Anchor Bible")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ABD")]), _vm._v(" – D. N. Freedman et al. (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Anchor Bible Dictionary")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("6 vols. (New York: Doubleday, 1992)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ANETS – Ancient Near Eastern Texts and Studies")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ATD – Das Alte Testament Deutsch")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("AYB – Anchor Yale Bible")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BEATAJ – Beiträge zur Erforschung des Alten Testaments und des Antiken Judentums")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BHQ – Biblia Hebraica Quinta")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("BHS")]), _vm._v(" – K. Elliger and W. Rudolph (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Biblia Hebraica Stuttgartensia")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }), _vm._v("5th edn (Stuttgart: Deutsche Bibelgesellschaft, 1997)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BIS – Biblical Interpretation Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("BZAW – Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("CBQ – Catholic Biblical Quarterly ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("CD – The Damascus Document")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("CHANE – Culture and History of the Ancient Near East")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("COS – ")]), _vm._v("W. W. Hallo and K. L. Younger, Jr. (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Context of Scripture: Canonical Compositions, Monumental Inscriptions, and Archival Documents from the Biblical World")]), _vm._v(", 3 vols. (Leiden/Boston: Brill, 2003)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("CSHB – Critical Studies in the Hebrew Bible")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("DCH")]), _vm._v(" – D. J. A. Clines (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Dictionary of Classical Hebrew")]), _vm._v(", 9 vols. (Sheffield: Sheffield Academic Press, 1993–2016)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("DDD – ")]), _vm._v("K. van der Toorn, B. Becking and P. W. van der Horst (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dictionary of Deities and Demons in the Bible")]), _vm._v(", 2nd edn (Leiden: Brill, 1999)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("DOTP – ")]), _vm._v("M. J. Boda and J. G. McConville (eds.),"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" Dictionary of the Old Testament Prophets")]), _vm._v(" (Downers Grove: InterVarsity Press; Nottingham: Inter-Varsity Press, 2012)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("evv")]), _vm._v(" – English versions")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("FAT – Forschungen zum Alten Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("GKC – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gesenius’ Hebrew Grammar")]), _vm._v(", edited and enlarged by E. Kautzsch, translated by A. E. Cowley (Oxford: Clarendon Press, 1910)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("HALOT")]), _vm._v(" – L. Koehler and W. Baumgartner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Hebrew and Aramaic Lexicon of the Old Testament: The New Koehler-Baumgartner in English")]), _vm._v(", 5 vols. (Leiden/ New York/Cologne: Brill, 1994)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("ITC – International Theological Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JBL – Journal of Biblical Literature ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JHS – Journal of Hebrew Scriptures ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("JSOTSup – Journal for the Study of the Old Testament Supplementary Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("JTS – Journal of Theological Studies ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("KAT – Kommentar zum Alten Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("LAI – Library of Ancient Israel")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("LHBOTS – Library of Hebrew Bible/Old Testament Study")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("lxx")]), _vm._v(" – Septuagint (pre-Christian Greek version of the Old Testament)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("mt")]), _vm._v(" – Masoretic Text (the standard Hebrew text of the Old Testament)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NAC – New American Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NCBC – New Century Bible Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NEAEHL")]), _vm._v(" – E. Stern (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Encyclopedia of Archaeological Excavations in the Holy Land")]), _vm._v(", 4 vols. (Jerusalem: Israel Exploration Society, 1993)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NETS")]), _vm._v(" – A. Pietersma and B. G. Wright (eds.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A New English Translation of the Septuagint")]), _vm._v(" (Oxford: Oxford University Press, 2007)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NICOT – New International Commentary on the Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NIDB – ")]), _vm._v("K. D. Sakenfeld (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Interpreter’s Dictionary of the Bible")]), _vm._v(", 5 vols. (Nashville: Abingdon Press, 2006–9)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("NIDOTTE")]), _vm._v(" – W. A. VanGemeren (ed.), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New International Dictionary of Old Testament Theology and Exegesis")]), _vm._v(", 5 vols. (Grand Rapids: Zondervan, 1997)")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("NSKAT – Neuer Stuttgarter Kommentar Altes Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("OAN – Oracles Against the Nations")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("OBO – Orbis Biblicus et Orientalis")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("OT – Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("OTL – Old Testament Library")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("OTS – Oudtestamentische studiën/Old Testament Studies")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("RB – Revue Biblique ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SCS – Septuagint Commentary Series")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SGOT – T&T Clark Study Guides to the Old Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SHBC – Smyth & Helwys Bible Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("SJT – Scottish Journal of Theology ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("SOTSM – Society for Old Testament Study Monographs")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("TOTC – Tyndale Old Testament Commentaries")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("VT – Vetus Testamentum ")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("VTSup – Vetus Testamentum Supplement")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WAW – Writings from the Ancient World")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WBC – Word Biblical Commentary")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("WMANT – Wissenschaftliche Monographien zum Alten und Neuen Testament")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("ZAW – Zeitschrift für die alttestamentliche Wissenschaft ")])]), _vm._v(" "), _c('h3', {
    staticClass: "b_head",
    attrs: {
      "id": "sigil_toc_id_1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/JA_contents"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/JA_imprint#BibAck",
      "id": "BibVer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bible versions")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("esv")]), _vm._v(" – The ESV Bible (The Holy Bible, English Standard Version), copyright © 2001 by Crossway, a publishing ministry of Good News Publishers. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("nab")]), _vm._v(" – The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New American Bible with Revised New")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Testament and Revised Psalms ")]), _vm._v("copyright © 1991, 1986, 1970 Confraternity of Christian Doctrine, Washington, D.C. and used by permission of the copyright owner. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("niv")]), _vm._v(" – The Holy Bible, New International Version (Anglicized edition). Copyright © 1979, 1984, 2011 by Biblica. Used by permission of Hodder & Stoughton Ltd, an Hachette UK company. All rights reserved ‘"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("niv")]), _vm._v("’ is a registered trademark of Biblica. UK trademark number 1448790.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("njb﻿ – ")]), _vm._v("THE NEW JERUSALEM BIBLE, copyright © 1985 by Darton, Longman & Todd, Ltd. and Doubleday, a division of Penguin Random House, Inc. Reprinted by permission.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("njps – ﻿")]), _vm._v("New Jewish Publication Society Tanakh, 1985. Source: The University of Nebraska Press. Published by the New Jewish Publication Society.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("nkjv")]), _vm._v(" – The New King James Version. Copyright © 1982 by Thomas Nelson, Inc. Used by permission. All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("nrsv")]), _vm._v(" – The New Revised Standard Version of the Bible, Anglicized Edition, copyright © 1989, 1995 by the Division of Christian Education of the National Council of the Churches of Christ in the USA. Used by permission. All rights reserved.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-041147da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/JA_abbrev.vue
// module id = 69
// module chunks = 0